import React from "react"
import { withRouter } from "react-router-dom"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hasError: false,
    }
  }

  componentDidCatch = (error, info) => {
    console.log("ERROR: ", error)
    console.log("INFO: ", info)

    this.setState({ hasError: true, error: error })
  }

  render = () => {
    let Component = this.props.component
    return !this.state.hasError ? (
      this.props.children
    ) : (
      <Component {...this.props} error={this.state.error} />
    )
  }
}

export default withRouter(ErrorBoundary)
